import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import { useLoadWidget, propsBoolean } from '../utils';
import { SgwtWidgetContext } from '../context';
const name = 'sgwt-web-analytics';
export const SgwtWebAnalytics = ({ siteId, baseUrl, disabled, disableUserTracking, debug, environment, userId, apmRumEnabled, apmRumServerurl, apmRumServiceName, id, onWidgetReady, }) => {
    const widget = useRef();
    const { infrastructure, registerWidget } = useContext(SgwtWidgetContext);
    useLoadWidget(name, infrastructure);
    useEffect(() => {
        if (!!widget.current) {
            onWidgetReady?.(widget.current);
            registerWidget('sgwtWebAnalytics', widget.current);
        }
    }, [widget, onWidgetReady, registerWidget]);
    return (_jsx("sgwt-web-analytics", { ref: widget, id: id, "site-id": siteId, "base-url": baseUrl, disabled: propsBoolean(disabled), "disable-user-tracking": propsBoolean(disableUserTracking), debug: propsBoolean(debug), environment: environment, "user-id": userId, "apm-rum-enabled": propsBoolean(apmRumEnabled), "apm-rum-server-url": apmRumServerurl, "apm-rum-service-name": apmRumServiceName }));
};
//# sourceMappingURL=SgwtWebAnalytics.js.map